import { render, staticRenderFns } from "./ReportDesktopLegacy.vue?vue&type=template&id=3756edfb"
import script from "./ReportDesktopLegacy.vue?vue&type=script&lang=js"
export * from "./ReportDesktopLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports